const notes = {
  colors: require('./ColorNotes.md'),
  icons: require('./IconNotes.md'),
  illustrations: require('./IllustrationsNotes.md'),
  textStyles: require('./TextStylesNotes.md'),
  grids: require('./GridNotes.md'),
  motion: require('./MotionNotes.md'),
  buttons: require('./ButtonNotes.md'),
  loadings: require('./LoadingNotes.md'),
  tabs: require('./TabsNotes.md'),
  dividers: require('./DividersNotes.md'),
  links: require('./LinksNotes.md'),
  actionIcons: require('./ActionIconNotes.md'),
  paginations: require('./PaginationNotes.md'),
  tooltips: require('./TooltipNotes.md'),
  tags: require('./TagsNotes.md'),
  badges: require('./BadgesNotes.md'),
  toggles: require('./TogglesNotes.md'),
  footer: require('./FooterNotes.md'),
  map: require('./MapNotes.md'),
  notifications: require('./NotificationNotes.md'),
  accordions: require('./AccordionNotes.md'),
  header: require('./HeaderNotes.md'),
  form: require('./FormNotes.md'),
  inputs: require('./InputsNotes.md'),
  verticalSectionMarker: require('./VerticalSectionMarkerNotes.md'),
  hotspots: require('./HotspotsNotes.md'),
  banners: require('./BannersNotes.md')
};

export default notes;



// WEBPACK FOOTER //
// ./src/containers/notes/index.js